var $8b9006cb5901da20$exports = {};
$8b9006cb5901da20$exports = {
    "loading": `\u{8F09}\u{5165}\u{4E2D}\u{2026}`,
    "placeholder": `\u{9078}\u{53D6}\u{2026}`
};


export {$8b9006cb5901da20$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
